import fnColor from './finmetrix-colors'

export function chartColors() {
  return [
    fnColor.LightBlue,
    fnColor.Green,
    fnColor.LightGray,
    fnColor.Blue,
    fnColor.Gray,
    fnColor.Red,
    '#0F243E',
    '#16365C',
    '#366092',
    '#538DD5',
    '#8DB4E2',
    '#C6D9F1',
    '#DDD9C4',
    '#C4BD97',
    '#948A54',
    '#595331',
    '#494529',
    '#1D1B10',
    '#F2DCDB',
    '#E6B8B7',
    '#DA9694',
    '#BF4C49',
    '#963634',
    '#632523',
    '#71FFB1',
    '#00E266',
    '#00B050',
    '#007033',
    '#00602B',
    '#003A1A',
    '#D9D9D9',
    '#BFBFBF',
    '#A6A6A6',
    '#808080',
    '#595959',
    '#404040',
    '#0B5FA4',
    '#960224',
  ]
}
